import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from "@material-ui/core/IconButton";
import {useTranslation} from "react-i18next";
import {useHistory} from "react-router-dom";
import {connect} from "react-redux";
import "firebase/compat/auth";
import LoggedInMenu from "./LoggedInMenu";

const RegularMenu = ({toggleDrawer, history}) => {
    const classes = useStyles();
    const {t} = useTranslation()
    return <div
        className={classes.list}
        role="presentation"
        onClick={toggleDrawer(false)}
        onKeyDown={toggleDrawer(false)}
    >
        <List>
        <ListItem button component={'a'} href='https://agendia.mx' >
                <ListItemText primary={t('homepage')}/>
            </ListItem>
            <ListItem button component={'a'} href='https://agendia.mx/signup' >
                <ListItemText primary={t('signup')}/>
            </ListItem>
            <ListItem button component={'a'} href='https://agendia.mx/login' >
                <ListItemText primary={t('login')}/>
            </ListItem>
        </List>
    </div>
}

const useStyles = makeStyles((theme) => ({
    list: {
        width: 250,
        backgroundColor: theme.palette.background,
        height: '100vh'
    },
}));

const TemporaryDrawer = ({children, isAuthenticated, dispatch}) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const history = useHistory();

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setIsOpen(open);
    };
    // const menu = regularMenu;

    return (
        <>
            <IconButton edge="start" onClick={toggleDrawer(true)} color="inherit"
                        aria-label="menu">
                {children}
            </IconButton>
            <Drawer anchor={'left'} open={isOpen} onClose={toggleDrawer(false)}>
                {isAuthenticated ? <LoggedInMenu toggleDrawer={toggleDrawer} history={history} dispatch={dispatch}/> :
                    <RegularMenu toggleDrawer={toggleDrawer} history={history} dispatch={dispatch}/>}
            </Drawer>
        </>
    )
}
const mapStateToProps = state => ({
    isAuthenticated: state.general.auth
})

export default connect(mapStateToProps)(TemporaryDrawer)